import React from 'react';
import { connect } from 'react-redux';
import { Button, ActionList, Popover } from 'components/ui';
import RenderInBody from 'components/shared/render_in_body';
import trackEvent from 'misc/trackEvent';
import { hasFeatureFlags } from 'utils/features';
import { Heading, HEADING_VARIANTS } from 'ui/Typography';
import FeatureFlag from 'components/shared/FeatureFlag';
import { routes } from '../../constants/config';
import IndexHeader from '../shared/index/header';
import { hasFeature } from '../../selectors/index';
import ScormModal from './scorm/ScormModal';
import CertificationPathCreationModal from './CertificationPathCreationModal';
import LessonCreationModal from './LessonCreationModal';
import ScenarioCreationModal from './ScenarioCreationModal';
import JourneyCreationModal from './Journeys/JourneyCreationModal';
import ScormHasMovedModal from './ScormHasMovedModal';
import LessonGenerateModal from './LessonGenerateModal';

class ContentHeader extends React.Component {
  state = {
    scormModalVisible: false,
    lessonModalVisible: false,
    scenarioModalVisible: false,
    journeyModalVisible: false,
    newContentPopoverVisible: false,
    certificationModalVisible: false,
    scormInLessonsModalVisible: false,
    lessonGenerateModalVisible: false,
  };

  openScormModal = () => {
    if (this.props.hasElearningInLessonsFeature) {
      this.setState({ scormInLessonsModalVisible: true });
    } else {
      this.setState({ scormModalVisible: true });
    }
  };

  closeScormModal = () => {
    if (this.props.hasElearningInLessonsFeature) {
      this.setState({ scormInLessonsModalVisible: false });
    } else {
      this.setState({ scormModalVisible: false });
    }
  };

  openLessonModal = () => {
    this.setState({ lessonModalVisible: true });
  };

  openJourneyModal = () => {
    this.setState({ journeyModalVisible: true });
  };

  openScenarioModal = () => {
    this.setState({ scenarioModalVisible: true });
  };

  closeScenarioModal = () => {
    this.setState({ scenarioModalVisible: false });
  };

  toggleNewContentPopover = () => {
    this.setState(state => ({
      newContentPopoverVisible: !state.newContentPopoverVisible,
    }));
  };

  closeLessonModal = () => {
    this.setState({ lessonModalVisible: false });
    trackEvent('lesson_creation_canceled_from_modal');
  };

  closeJourneyModal = () => {
    this.setState({ journeyModalVisible: false });
  };

  openCertificationModal = () => {
    this.setState({ certificationModalVisible: true });
  };

  closeCertificationModal = () => {
    this.setState({ certificationModalVisible: false });
  };

  openLessonGenerateModal = () => {
    this.setState({
      lessonModalVisible: false,
      lessonGenerateModalVisible: true,
    });
  };

  closeLessonGenerateModal = () => {
    this.setState({ lessonGenerateModalVisible: false });
  };

  render() {
    const {
      hasScormFeature,
      hasPracticeScenario,
      i18n,
      userCanCreateContent,
      canManageContentLibrary,
      canManageTemplateLibrary,
      hasActiveTemplates,
      hasLearningJourneysFeature,
      canReadWriteJourneys,
    } = this.props;

    const {
      newContentPopoverVisible,
      scormModalVisible,
      lessonModalVisible,
      scenarioModalVisible,
      journeyModalVisible,
      certificationModalVisible,
      scormInLessonsModalVisible,
      lessonGenerateModalVisible,
    } = this.state;

    const actionListActivator = (
      <Button
        onClick={this.toggleNewContentPopover}
        icon="add"
        className="Index-newContentButton trk_button_readiness_add-content"
      >
        {t('contents.index.header.new_content')}
      </Button>
    );

    const newLessonListItem = hasActiveTemplates
      ? {
          content: t('contents.index.header.new_lesson'),
          url: '/templates/gallery',
          pendoClassName:
            'trk_select_readiness_new-lesson-from-content-dropdown',
        }
      : {
          content: t('contents.index.header.new_lesson'),
          onClick: this.openLessonModal,
          pendoClassName:
            'trk_select_readiness_new-lesson-from-content-dropdown',
        };

    const actionList = (
      <div className="d-f ai-c m-fd-c">
        {(canManageContentLibrary || canManageTemplateLibrary) && (
          <a
            className="ff-ss fz-16 ml-16 mr-16 c-brand-blue"
            href={routes.CONTENT.LIBRARY}
          >
            {t('contents.library.title')}
          </a>
        )}
        <div className="Index-newButtonsContainer">
          <Popover
            className="Index-newButtonsPopover"
            activator={actionListActivator}
            visible={newContentPopoverVisible}
            align="right"
            onClose={this.toggleNewContentPopover}
          >
            <div className="Index-newButtonsActionList">
              <ActionList
                items={[
                  newLessonListItem,
                  {
                    content: t('contents.index.header.new_path'),
                    url: routes.NEW_PATH,
                    pendoClassName:
                      'trk_select_readiness_new-path-from-content-dropdown',
                  },
                  hasScormFeature && {
                    content: t('contents.index.header.new_scorm_lesson'),
                    onClick: this.openScormModal,
                  },
                  hasPracticeScenario && {
                    content: t('contents.index.header.new_practice_scenario'),
                    onClick: this.openScenarioModal,
                    pendoClassName:
                      'trk_select_readiness_new-scenario-from-content-dropdown',
                  },
                  {
                    content: t('contents.index.header.new_certification'),
                    onClick: this.openCertificationModal,
                    pendoClassName:
                      'trk_select_readiness_new-certification-from-content-dropdown',
                  },
                  hasLearningJourneysFeature &&
                    canReadWriteJourneys && {
                      content: t('contents.index.header.new_journey'),
                      onClick: this.openJourneyModal,
                    },
                ]}
              />
            </div>
          </Popover>
        </div>
      </div>
    );

    return (
      <div>
        <FeatureFlag
          fallback={
            <IndexHeader
              title={
                <span>
                  <span className="u-hideBelowXS">
                    {t('contents.index.header.learning')}{' '}
                  </span>
                  {t('contents.index.header.content')}
                </span>
              }
              actions={userCanCreateContent && actionList}
            />
          }
        >
          <div className="Index-header pt-12 pb-6">
            <Heading className="pb-8" variant={HEADING_VARIANTS.H4}>
              <FeatureFlag
                features="readiness-enable-unification"
                fallback={<>{t('contents.index.header.content')}</>}
              />
            </Heading>
            {userCanCreateContent && actionList}
          </div>
        </FeatureFlag>
        <ScormHasMovedModal
          visible={scormInLessonsModalVisible}
          closeModal={this.closeScormModal}
        />
        {scormModalVisible && (
          <RenderInBody>
            <ScormModal
              closeScormModal={this.closeScormModal}
              scormModalVisible={scormModalVisible}
              workspaces={this.props.workspacesForSelect}
              hasWorkspaceFeature={this.props.hasWorkspaceFeature}
              i18n={i18n}
            />
          </RenderInBody>
        )}
        {lessonModalVisible && (
          <LessonCreationModal
            openLessonGenerateModal={this.openLessonGenerateModal}
            closeModal={this.closeLessonModal}
          />
        )}
        {scenarioModalVisible && (
          <ScenarioCreationModal closeModal={this.closeScenarioModal} />
        )}
        {certificationModalVisible && (
          <CertificationPathCreationModal
            closeModal={this.closeCertificationModal}
          />
        )}
        {journeyModalVisible && (
          <JourneyCreationModal closeModal={this.closeJourneyModal} />
        )}
        {lessonGenerateModalVisible && (
          <LessonGenerateModal
            closeModal={this.closeLessonGenerateModal}
            openLessonGenerateModal={this.openLessonModal}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  hasScormFeature: hasFeature(state, 'scorm'),
  hasWorkspaceFeature: hasFeature(state, 'workspaces'),
  hasPracticeScenario: hasFeature(state, 'on_demand_practice'),
  hasLinkedElements: hasFeature(state, 'linked_elements'),
  hasScormFullWidthFeature: hasFeatureFlags(['display_scorm_full_width']),
  hasElearningInLessonsFeature: hasFeatureFlags(['elearning_lesson_section']),
  canManageContentLibrary: state.data.meta.currentUser.canManageContentLibrary,
  hasLearningJourneysFeature: hasFeatureFlags(['readiness-learning-journeys']),
  canManageTemplateLibrary:
    state.data.meta.currentUser.canManageTemplateLibrary,
  userCanCreateContent: state.data.meta.currentUser.canCreateContent,
  workspacesForSelect: state.data.meta.workspaceOptions,
  hasActiveTemplates: state.data.meta.currentUser.hasActiveTemplates,
  canReadWriteJourneys: state.data.meta.currentUser.canReadWriteJourneys,
});

export default connect(mapStateToProps)(ContentHeader);
